import { atom } from 'jotai';

export const drawersAtom = atom<string[]>([]);
